export default {
  general: {
    name: "DDMRP Beer Game",
    yes: "Да",
    no: "Нет",
    previous: "Предыдущий",
    next: "Следующий",
    ok: "ОК",
    confirmation: "Подтверждение",
    week: "Неделя",
    units: "{nbr} юнит(а) | {nbr} юнит(а) | {nbr} юнитов",
    smallWeek: "W",
    timerMessage: "Ваш лимит времени превышен, сделайте ход как можно скорее!",
    wrongValue: "Неверное значение",
    gameFinished: "Игра закончена",
    gamePaused: "Игра на паузе",
    required: "Необходимо",
    stockFrom: "Остаток от",
    assemblyStock: "Объединенный остаток",
    testMode: "Данная игра находится в тестовом режиме. Она не может быть использована в коммерческих целях."
  },
 
  instructions: {
    chooseAvatar: "Выберете себе аватар",
    title: "Инструкции",
    step: "Шаг",
    ready: "Готов",
    wait: "Пожалуйста, дождитесь готовности других игроков",
    start: "Начать игру"
  },
 
  steps: {
    bufferSetup: "Настройки буфера",
    clientOrder: "Заказ клиента",
    clientShipment: "Клиентские отгрузки",
    supplierShimpentWaiting: "В ожидании поставки",
    board: "Панель управления",
    supplierShipments: "Поставки поставщиков",
    supplierOrders: "Заказы поставщика",
    productionBatch: "Старт производства",
    productionShipments: "Поставки на производство",
    startNewWeek: "Начать новую неделю",
    youCanStartNewWeek: "Вы можете начать новую неделю",
    inProgressProduction: "Производство в процессе",
    flowEquationCalc: "Уравнение Сальдо Потока",
    clientOrderTitleMessage: "Получен клиентский заказ"
  },
 
  clientsShimpents: {
    chooseQuantity: "Пожалуйста, введите необходимое количество",
    notMax: "Пожалуйста, проверьте, объем поставки должен соответствовать вашим макс. возможностям",
    remains: "Заказы клиентов (просроченные и сегодняшние) : ",
    ok : "Подтвердить отправку",
    shipmentsResume: "Вы отправили {nbr} юнит(а) вашим клиентам | Вы отправили {nbr} юнитов вашим клиентам",
    remainResume: "У вас есть невыполненный заказ на {nbr} юнит(а) | У вас есть невыполненный заказ на {nbr} юнитов"
  },
 
  board: {
    cantOrder: "Сейчас нельзя создать заказ",
    cantProduce: "Сейчас нельзя создать производственный заказ"
  },
 
  suppliersShipments: {
    shipments: "Поставки от",
    production: "Вы произвели {nbr} юнит(а) | Вы произвели {nbr} юнитов",
    getShipments: "Получено",
    waitShipment: "Пожалуйста, дождитесь поставок",
    stockChange: "Ваш текущий запас сейчас {nbr} юнит(а) | Ваш текущий запас сейчас {nbr} юнитов",
    stockChangeTitle: "Обновите ваш текущий запас"
  },
 
  suppliersOrders: {
    maxOrder: "Максимальный заказ ",
    ordersTo: "Заказать",
    remainsAlert: "Напоминаем, вам не удалось доставить все заказы клиентов!",
    production: "Количество к старту",
    orders: "Заказы",
    ok : "Подтвердить заказы поставщиков",
    okProduction: "Подтвердить старт производства"
  },
 
  stats: {
    suppliersRemains: "Невыполненные заказы поставщиков",
    buffers: "Буферы",
    resume: "Суммарно",
    orders: "Заказы",
    stock: "Текущий запас",
    remains: "Дефициты",
    cost: "Стоимость",
    stockDelay: "Текущий запас и дефициты",
    companies: "Узел",
    red: "Красная зона",
    yellow: "Желтая зона",
    green: "Зеленая зона",
    flowEquation: "Сальдо потока"
  },
 
  dd: {
    cmj: "Среднедневное потребление",
    leadTime: "Lead time",
    variabilityFactor: "Фактор Вариабельности",
    delayFactor: "Фактор LT",
    availableStock: "Запас в наличии",
    clientsRemains: "Подтвержденный спрос",
    suppliersRemains: "Заказы на поставку",
    AverageStockLevelTarget: "Средний целевой запас",
    falseOrder: "Неправильное количество к заказу",
    applyAutoCmj: "Автоприменение рассчитанного среднесуточного потребления",
    calculatedCMJ: "Рассчитанное среднесуточное потребление"
  },
 
  debrief: {
    resume: {
      name: "Имя",
      level: "Ранг",
      resume: "Краткая сводка",
      averageOrderQuantity: "В среднем, спрос к поставщику",
      averageRequestQuantity: "В среднем, потребительский спрос",
      range: "Диапазон спроса",
      otd: "Своевременных поставок",
      delaysDepth: "Задержка в неделях",
      averageStock: "В среднем, запас в наличии",
      stockCost: "Стоимость запасов",
      delayCost: "Стоимость дефицитов",
      cost: "Общая стоимость",
    }
  },
 
  user : {
    noParties : 'Нет соответствий с играми по данному коду и учетной записи',
    falseTrainningKey : 'Неверный тренировочный ключ',
    welcome : "Добро пожаловать в игру ",
    noMorePlace : "Для этой игры не осталось свободных мест",
    notOpen: "Игра открыта",
    logoutConfirmation: "Вы уверены что хотите покинуть игру",
    sessionExpired: "Срок действия вашей сессии истёк, пожалуйста, войдите снова"
  },
 
  store : {
    error : "Ошибка: "
  }
}